import React from 'react'

import './submit-form.scss'

import Markdown from '../Markdown/markdown'



class SubmitForm extends React.Component {
  constructor(props) {
    super(props)
  }

  renderField(name, value) {
    if (name && value) {
      return (
        <input type="hidden" name={ name } value={ value }/>
      )
    } else {
      return null
    }
  }
 
  render() {
    const { localization, content } = this.props
    const { actionUrl, description, layout, formId, u } = content
    const uField = this.renderField('u', u)
    const idField = this.renderField('id', formId)
    
    return (
      <div className="form-container">
        { description ? (
          <div className="description">
           <Markdown content={description.description} />
          </div>
         ) : null }
        <form action={ actionUrl } method="POST" className="submit-form">
          <input 
            type="email"
            placeholder={ localization('global.email') }
            className="input email"
            name="MERGE0"/>
          { uField }
          { idField }
          { !layout ? (
            <div>
              <textarea 
                className="textarea"
                placeholder={ localization('global.partnersFormPlaceholder') }
                name="message"/>
            </div>
          ): null }
          <button className="btn primary btn-submit" type="submit">{ localization('global.submit') }</button>
        </form>
      </div>
    )
  }
}

export default SubmitForm


// WEBPACK FOOTER //
// ./src/components/SubmitForm/submit-form.js